import React from 'react';
import { observable, action, runInAction } from 'mobx';
import { PAGE_SIZE_DEFAULT } from '../constants/appConstant';
import indexManagementAPI from '../apis/indexManagementAPI'
import alertMessage from '../utils/alertMessage'

export default class IndexManagementStore {
  constructor(rootStore) {
    this.rootStore = rootStore;
  }
  @observable isFetching = false;
  @observable pageSize = PAGE_SIZE_DEFAULT;
  @observable pageNo = 1;
  @observable currIndex = 0
  @observable itemCount = 0;
  @observable pageSizeGroup = PAGE_SIZE_DEFAULT;
  @observable pageNoGroup = 1;
  @observable currIndexGroup = 0
  @observable itemCountGroup = 0;

  /*SearchResult start*/
  @observable indexSetList = []
  @action
  async onSearchAction(pageNo, pageSize) {
    this.isFetching = true;
    this.pageNo = pageNo;
    this.pageSize = pageSize;
    this.itemCount = 0
    try {
      this.indexSetList = [];
      const response = await indexManagementAPI.searchAction(pageNo, pageSize);
      runInAction(() => {
        this.isFetching = false;
        if (response.data.code === 0) {
          this.indexSetList = response.data.data?.records
          this.itemCount = response.data.data?.total
        }
      })
    } catch (err) {
      alertMessage.error(err.message);
      runInAction(() => {
        this.isFetching = false;
      });
    }
  }
  /*SearchResult end*/
  /*add */
  @action
  async onAddAction(params) {
    this.isFetching = true
    try {
      const response = await indexManagementAPI.addAction(params)
      runInAction(() => {
        this.isFetching = false;
        if (response.data.code === 0) {
          alertMessage.success('Add Success!')
          this.onSearchAction(this.pageNo, this.pageSize)
        } else {
          alertMessage.error('Add Failed!' + response.data.messageEn + '')
        }
      })
      return response
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false;
      });
    }
  }
  /*get */
  @observable detailsObj = null
  @action
  async onGetAction(id) {
    this.isFetching = true
    try {
      const response = await indexManagementAPI.getAction(id)
      runInAction(() => {
        this.isFetching = false;
        if (response.data.code === 0) {
          this.detailsObj = response.data.data || null
        }
      })
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false;
      });
    }
  }
  /*edit */
  @action
  async onEditAction(params, id) {
    this.isFetching = true
    try {
      const response = await indexManagementAPI.editAction(params, id)
      runInAction(() => {
        this.isFetching = false;
        if (response.data.code === 0) {
          alertMessage.success('Edit Success!')
          this.onSearchAction(this.pageNo, this.pageSize)
        } else {
          alertMessage.error('Edit Failed!' + response.data.messageEn + '')
        }
      })
      return response
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false;
      });
    }
  }
  /*delete */
  @action
  async onDeleteAction(id) {
    this.isFetching = true
    try {
      const response = await indexManagementAPI.deleteAction(id);
      runInAction(() => {
        this.isFetching = false;
        if (response.data.code === 0) {
          alertMessage.success('Delete Success!')
          this.onSearchAction(this.pageNo, this.pageSize)
        } else {
          alertMessage.error('Delete Failed!' + response.data.messageEn + '')
        }
      });
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false;
      });
    }
  }
  /*get apiName*/
  @observable apiNameList = []
  @action
  async onGetApiNameAction(params) {
    this.apiNameList = []
    try {
      const response = await indexManagementAPI.getApiNameAction(params)
      console.log( response.data.data);
      runInAction(() => {
        if (response.data.code === 0) {
          this.apiNameList = response.data.data || null
        }
      })
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        // this.isFetching = false;
      });
    }
  }
  /*get apiName*/
  @observable sampleData = []
  @action
  async onGetSampleDataAction(id) {
    this.isFetching = true
    this.sampleData = []
    try {
      const response = await indexManagementAPI.getSampleDataAction(id)
      runInAction(() => {
        this.isFetching = false;
        if (response.data.code === 0) {
          this.sampleData = this.data2Tree(JSON.parse(response.data.data), null, null, false)
        } else {
          alertMessage.error(response.data.messageEn)
        }
      })
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false;
      });
    }
  }
  @action
  onChangeSampleData(value) {
    this.sampleData = value
  }

  @action
  data2Tree(baseData) {
    let array = [];
    if (baseData !== null && typeof baseData === 'object') {
      for (let i in baseData) {
        this.getChildren(array, baseData[i], i);
      }
    }
    return array
  }
  @action
  getChildren(array, data, name) {
    if (data instanceof Array) {
      let obj = {};
      if (typeof data[0] === 'object') {
        obj = this.getObj(name, null, true, true);
      } else {
        obj = this.getObj(name, null, true, false);
      }
      let childrenObj = [];
      for (let i in data[0]) {
        if (typeof data[0][i] === 'object') {
          this.getChildren(childrenObj, data[0][i], i);
        } else {
          childrenObj.push(this.getObj(i, null, false, false));
        }
      }
      obj.tree = childrenObj;
      array.push(obj);
    }
    if (!(data instanceof Array) && typeof data === 'object') {
      for (let i in data) {
        let pathName = name === null ? i : name + '.' + i;
        if (typeof data[i] === 'object') {
          this.getChildren(array, data[i], pathName);
        } else {
          array.push(this.getObj(pathName, null, false, false));
        }
      }
    }
    if (typeof data !== 'object') {
      array.push(this.getObj(name, null, false, false));
    }
    if (data === null) {
      array.push(this.getObj(name, null, false, false));
    }
  }
  @action
  getObj(name, children, isChildren, isArray) {
    let obj = {
      'arrayType': isArray && isChildren ? 'STRUCT' : isArray ? 'STRING' : null,
      'fieldType': isArray ? 'ARRAY' : 'STRING',
      'path': name,
      'tree': children
    };
    return obj;
  }
  @action
  onChangePageNumAction(pageNo, pageSize) {
    if (this.pageNo === pageNo && (!pageSize || this.pageSize === pageSize)) {
      return;
    }
    runInAction(() => {
      this.pageNo = pageNo;
      this.pageSize = pageSize;
    });
    this.onSearchAction(this.pageNo, this.pageSize)
  }





  /*SearchResult start*/
  @observable indexGroupSetList = []
  @action
  async onSearchGroupAction(pageNo, pageSize) {
    this.isFetching = true;
    this.pageNoGroup = pageNo;
    this.pageSizeGroup = pageSize;
    this.itemCountGroup = 0
    try {
      this.indexGroupSetList = [];
      const response = await indexManagementAPI.searchGroupAction(pageNo, pageSize);
      runInAction(() => {
        this.isFetching = false;
        if (response.data.code === 0) {
          this.indexGroupSetList = response.data.data?.records || []
          this.itemCountGroup = response.data.data?.total
        }
      })
    } catch (err) {
      alertMessage.error(err.message);
      runInAction(() => {
        this.isFetching = false;
      });
    }
  }
  /*SearchResult end*/
  /*add permission*/
  @action
  async onAddGroupnAction(params) {
    this.isFetching = true
    try {
      const response = await indexManagementAPI.addGroupAction(params)
      runInAction(() => {
        this.isFetching = false;
        if (response.data.code === 0) {
          alertMessage.success('Add Success!')
          this.onSearchGroupAction(this.pageNo, this.pageSize)
        } else {
          alertMessage.error('Add Failed!' + response.data.messageEn + '')
        }
      })
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false;
      });
    }
  }
  /*get edit permission*/
  @observable detailsObj = null
  @action
  async onGetGroupAction(id) {
    this.isFetching = true
    try {
      const response = await indexManagementAPI.getGroupAction(id)
      console.log(response.data.data);
      runInAction(() => {
        this.isFetching = false;
        if (response.data.code === 0) {
          this.detailsObj = response.data.data || null
        }
      })
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false;
      });
    }
  }
  /*edit permission*/
  @action
  async onEditGroupAction(params, id) {
    this.isFetching = true
    try {
      const response = await indexManagementAPI.editGroupAction(params, id)
      runInAction(() => {
        this.isFetching = false;
        if (response.data.code === 0) {
          alertMessage.success('Edit Success!')
          this.onSearchGroupAction(this.pageNo, this.pageSize)
        } else {
          alertMessage.error('Edit Failed!' + response.data.messageEn + '')
        }
      })
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false;
      });
    }
  }
  /*delete permission*/
  @action
  async onDeleteGroupAction(id) {
    this.isFetching = true
    try {
      const response = await indexManagementAPI.deleteGroupAction(id);
      runInAction(() => {
        this.isFetching = false;
        if (response.data.code === 0) {
          alertMessage.success('Delete Success!')
          this.onSearchGroupAction(this.pageNo, this.pageSize)
        } else {
          alertMessage.error('Delete Failed!' + response.data.messageEn + '')
        }
      });
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false;
      });
    }
  }
  @action
  onChangePageNumGroupAction(pageNo, pageSize) {
    if (this.pageNoGroup === pageNo && (!pageSize || this.pageSizeGroup === pageSize)) {
      return;
    }
    runInAction(() => {
      this.pageNoGroup = pageNo;
      this.pageSizeGroup = pageSize;
    });
    this.onSearchGroupAction(this.pageNoGroup, this.pageSizeGroup)
  }
  /*get apiName*/
  @observable indexNameList = []
  @action
  async onGetIndexNameAction() {
    this.isFetching = true
    this.indexNameList = []
    try {
      const response = await indexManagementAPI.getIndexNameAction()
      runInAction(() => {
        this.isFetching = false;
        if (response.data.code === 0) {
          this.indexNameList = response.data.data || null
        }
      })
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false;
      });
    }
  }
}
